// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 79 ? "48bf1727" : chunkId) + "." + {"79":"ac4e4b7ea69570a1e416","447":"964230e47ea258a6bb49"}[chunkId] + ".js";
};